<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import Button from 'dashboard/components-next/button/Button.vue';
import FilterPill from 'dashboard/components-next/filter-bar/FilterPill.vue';

const props = defineProps({
  activeSort: {
    type: String,
    default: 'last_activity_at',
  },
  activeOrdering: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['update:sort']);

const { t } = useI18n();

const isMenuOpen = ref(false);

// No formato da pílula: { id, name }.
const sortMenus = [
  {
    name: t('CONTACTS_LAYOUT.HEADER.ACTIONS.SORT_BY.OPTIONS.NAME'),
    id: 'name',
  },
  {
    name: t('CONTACTS_LAYOUT.HEADER.ACTIONS.SORT_BY.OPTIONS.EMAIL'),
    id: 'email',
  },
  {
    name: t('CONTACTS_LAYOUT.HEADER.ACTIONS.SORT_BY.OPTIONS.COMPANY'),
    id: 'company_name',
  },
  {
    name: t('CONTACTS_LAYOUT.HEADER.ACTIONS.SORT_BY.OPTIONS.COUNTRY'),
    id: 'country',
  },
  {
    name: t('CONTACTS_LAYOUT.HEADER.ACTIONS.SORT_BY.OPTIONS.CITY'),
    id: 'city',
  },
  {
    name: t('CONTACTS_LAYOUT.HEADER.ACTIONS.SORT_BY.OPTIONS.LAST_ACTIVITY'),
    id: 'last_activity_at',
  },
  {
    name: t('CONTACTS_LAYOUT.HEADER.ACTIONS.SORT_BY.OPTIONS.CREATED_AT'),
    id: 'created_at',
  },
];

const orderingMenus = [
  {
    name: t('CONTACTS_LAYOUT.HEADER.ACTIONS.ORDER.OPTIONS.ASCENDING'),
    id: '',
  },
  {
    name: t('CONTACTS_LAYOUT.HEADER.ACTIONS.ORDER.OPTIONS.DESCENDING'),
    id: '-',
  },
];

// A pílula devolve uma lista de um item; o evento segue levando { sort, order }.
const handleSortChange = ([value]) => {
  emit('update:sort', { sort: value, order: props.activeOrdering });
};

const handleOrderChange = ([value]) => {
  emit('update:sort', { sort: props.activeSort, order: value });
};
</script>

<template>
  <div class="relative">
    <Button
      icon="i-lucide-arrow-down-up"
      color="slate"
      size="sm"
      variant="ghost"
      :class="isMenuOpen ? 'bg-n-alpha-2' : ''"
      @click="isMenuOpen = !isMenuOpen"
    />
    <div
      v-if="isMenuOpen"
      v-on-clickaway="() => (isMenuOpen = false)"
      class="absolute top-full mt-1 ltr:-right-32 rtl:-left-32 sm:ltr:right-0 sm:rtl:left-0 flex flex-col items-start gap-2 bg-n-alpha-3 backdrop-blur-[100px] border border-n-weak w-72 rounded-xl p-4 z-50"
    >
      <!-- UI-FILTROS-01: campo e sentido são pílulas únicas sem ✕ (clearable=false):
           sempre há um escolhido. O nome ("Classificar por:", "Ordenação:") fica só
           na pílula; escrito também à esquerda, aparecia duas vezes, como no menu das
           Notificações. -->
      <FilterPill
        :label="t('CONTACTS_LAYOUT.HEADER.ACTIONS.SORT_BY.LABEL')"
        :options="sortMenus"
        :model-value="[activeSort]"
        single
        :clearable="false"
        @update:model-value="handleSortChange"
      />
      <FilterPill
        :label="t('CONTACTS_LAYOUT.HEADER.ACTIONS.ORDER.LABEL')"
        :options="orderingMenus"
        :model-value="[activeOrdering]"
        single
        :clearable="false"
        @update:model-value="handleOrderChange"
      />
    </div>
  </div>
</template>
